import CategoryReelTabBar from "./CategoryReelTabBar";
export default CategoryReelTabBar;
